import { atom } from "recoil";

export interface HttpStepLog {
    stepId: string;
    stepType: string;
    parsedBodyPaths: string[][];
    headersPaths: string[][];
    queryPaths: string[][];
}

export type DiagramLogData = HttpStepLog[];

export const diagramLogAtom = atom<DiagramLogData>({
    key: "diagramLog",
    default: [],
});
